export default [
    {
        "id": 10046,
        "bpId": 12781306,
        "clientNumber": null,
        "compensationType": "ASLRY",
        "payFrequency": "MLY",
        "amount": 72551.0,
        "action": null,
        "source": "userEntered",
        "tracPlanNumber": "TB0344",
        "sponsorProvidedPayFreq": false
    },
    {
        "id": 10047,
        "bpId": 12781306,
        "clientNumber": null,
        "compensationType": "ASLRY",
        "payFrequency": "MLY",
        "amount": 40000.0,
        "action": null,
        "source": "userEntered",
        "tracPlanNumber": "TB1298",
        "sponsorProvidedPayFreq": false
    },
    {
        "id": 10048,
        "bpId": 12781306,
        "clientNumber": null,
        "compensationType": "ASLRY",
        "payFrequency": "MLY",
        "amount": 40000.0,
        "action": null,
        "source": "userEntered",
        "tracPlanNumber": "TB1299",
        "sponsorProvidedPayFreq": false
    }
]
